import {i18n} from '@netx/core/i18n';

export default {
	read: {
		default: i18n.t('i18n.errorAlert'),
	},
	update: {
		default: i18n.t('i18n.errorAlert'),
	},
};
